// Generated types for LLMTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { IslandRootReadAPI, IslandRootWriteAPI } from '../../shared/types/islandroot';
import { IslandRootReadAPISchemaObject, IslandRootWriteAPISchemaObject } from '../../shared/types/islandroot';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface LLMTaskReadAPI extends IslandRootReadAPI {
  execution_prompt?: string | null;
  exec_status?: "created" | "running" | "done" | "error" | "timeout" | "canceled";
  started_at?: string | null;
  completed_at?: string | null;
  request_tokens?: number | null;
  response_tokens?: number | null;
  total_tokens?: number | null;
}

export interface LLMTaskWriteAPI extends IslandRootWriteAPI {
  execution_prompt?: string | null;
  exec_status?: "created" | "running" | "done" | "error" | "timeout" | "canceled";
  started_at?: string | null;
  completed_at?: string | null;
  request_tokens?: number | null;
  response_tokens?: number | null;
  total_tokens?: number | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const LLMTaskReadAPISchemaObject = IslandRootReadAPISchemaObject.extend({
  execution_prompt: z.string().nullable().optional(),
  exec_status: z.enum(["created", "running", "done", "error", "timeout", "canceled"]).optional(),
  started_at: z.string().nullable().optional(),
  completed_at: z.string().nullable().optional(),
  request_tokens: z.number().nullable().optional(),
  response_tokens: z.number().nullable().optional(),
  total_tokens: z.number().nullable().optional(),
}).passthrough();
export const LLMTaskReadAPISchema: z.ZodType<LLMTaskReadAPI> = LLMTaskReadAPISchemaObject;

export const LLMTaskWriteAPISchemaObject = IslandRootWriteAPISchemaObject.extend({
  execution_prompt: z.string().nullable().optional(),
  exec_status: z.enum(["created", "running", "done", "error", "timeout", "canceled"]).optional(),
  started_at: z.string().nullable().optional(),
  completed_at: z.string().nullable().optional(),
  request_tokens: z.number().nullable().optional(),
  response_tokens: z.number().nullable().optional(),
  total_tokens: z.number().nullable().optional(),
}).passthrough();
export const LLMTaskWriteAPISchema: z.ZodType<LLMTaskWriteAPI> = LLMTaskWriteAPISchemaObject;
